<nav
  [attr.aria-label]="state.title"
  [class.mobile-open]="navStateService.isOpen$ | async"
  [class.slide-left]="sliderService.hasPrevious$ | async"
  [class.slide-right]="sliderService.hasNext$ | async"
  >
  @if (state.name === 'secondary') {
    <ui-nav-controls-mobile
      (collapse)="navStateService.collapseItem()"
      (switchOpen)="navStateService.switchOpen()"
      [isExpanded]="navStateService.isExpanded$ | async"
      [isOpen]="navStateService.isOpen$ | async"
    ></ui-nav-controls-mobile>
    <ui-nav-controls-slide
      (slide)="sliderService.slideBy($event)"
      [current]="sliderService.current$ | async"
      [max]="sliderService.max$ | async"
    ></ui-nav-controls-slide>
  }

  <ui-nav-menu-tree
    (selected)="onSelected($event)"
    [ngClass]="typeClass"
    [root]="state"
  ></ui-nav-menu-tree>
</nav>
